<script>
export default {
  name: "WebHome",
  data() {
    return {
      posts: [],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      loading: false,
    };
  },
  mounted() {
    this.fetchPosts();
  },
  methods: {
    fetchPosts() {
      this.loading = true;
      this.$api
        .webPostsList({
          page: this.currentPage,
          page_size: this.pageSize,
        })
        .then((res) => {
          if (res.code === 0) {
            this.posts = res.data.data || [];
            this.total = res.data.total || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchPosts();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goToDetail(id) {
      this.$router.push(`/post/${id}`);
    },
  },
};
</script>

<template>
  <div class="web-home">
    <div v-loading="loading" class="posts-container">
      <!-- 文章网格 -->
      <el-row :gutter="24" type="flex" class="post-row">
        <el-col
          :span="12"
          :xs="24"
          :sm="24"
          :md="12"
          v-for="post in posts"
          :key="post.id"
        >
          <div class="post-card-wrap">
            <div class="post-card" @click="goToDetail(post.id)">
              <div class="card-content">
                <h3 class="title">{{ post.title }}</h3>
                <div class="meta">
                  <span class="date">{{ post.publish_at }}</span>
                  <span class="category">{{ post.category.name }}</span>
                </div>
                <p class="description" v-if="post.description">
                  {{ post.description }}
                </p>
              </div>
              <div class="card-footer">
                <span class="read-more">阅读全文 →</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 分页 -->
      <div class="pagination-container" v-if="total > 0">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && posts.length === 0" class="empty-state">
        <el-empty description="暂无文章"></el-empty>
      </div>
    </div>
  </div>
</template>

<style scoped>
.web-home {
  padding: 10px;
  min-height: calc(100vh - 120px);
}

.posts-container {
  margin: 0 auto;
}

.post-row {
  flex-wrap: wrap;
}

/* 卡片样式 */
.post-card-wrap {
  height: 100%;
  padding-bottom: 24px;
}

.post-card {
  display: flex;
  flex-direction: column;
  background-color: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 180px;
}

.post-card-wrap:hover .post-card {
  background-color: #1f232b;
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  border-color: rgba(99, 162, 120, 0.3);
}

.card-content {
  flex: 1;
}

/* 标题 */
.title {
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  color: #f2f2f2;
  transition: color 0.25s ease;
}

.post-card-wrap:hover .title {
  color: #63a278;
}

/* 元信息 */
.meta {
  margin: 0 0 16px 0;
  line-height: 1.5;
  color: #9ca3af;
  font-size: 13px;
}

.meta span {
  display: inline-block;
  margin-right: 16px;
}

.meta .date::before {
  content: "📅 ";
  opacity: 0.7;
}

.meta .category::before {
  content: "📁 ";
  opacity: 0.7;
}

/* 描述 */
.description {
  margin: 0;
  line-height: 1.8;
  font-size: 14px;
  color: #b0b0b0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 卡片底部 */
.card-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.read-more {
  color: #63a278;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.25s ease;
}

.post-card-wrap:hover .read-more {
  color: #7ab992;
  letter-spacing: 1px;
}

/* 分页样式 */
.pagination-container {
  margin-top: 40px;
  text-align: center;
  padding: 20px 0;
}

::v-deep .el-pagination {
  display: inline-flex;
}

::v-deep .el-pagination.is-background .el-pager li {
  background-color: #1a1d24;
  color: #b0b0b0;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #63a278;
  color: #fff;
  border-color: #63a278;
}

::v-deep .el-pagination.is-background .el-pager li:hover {
  color: #63a278;
}

::v-deep .el-pagination.is-background .btn-prev,
::v-deep .el-pagination.is-background .btn-next {
  background-color: #1a1d24;
  color: #b0b0b0;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

::v-deep .el-pagination.is-background .btn-prev:hover,
::v-deep .el-pagination.is-background .btn-next:hover {
  color: #63a278;
}

::v-deep .el-pagination__total {
  color: #9ca3af;
}

/* 空状态 */
.empty-state {
  padding: 80px 0;
  text-align: center;
}

::v-deep .el-empty__description {
  color: #6b7280;
}

/* 响应式 */
@media (max-width: 768px) {
  .web-home {
    padding: 15px;
  }

  .post-card {
    padding: 20px;
    min-height: auto;
  }

  .title {
    font-size: 18px;
  }

  .description {
    font-size: 13px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
}
</style>
